import { apiClient } from './client';
import { Programme } from '../types/projects';

export const programmesApi = {
  list: () => apiClient.get<{ data: Programme[] }>('/api/programmes'),
  get: (id: number) => apiClient.get<{ data: Programme }>(`/api/programmes/${id}`),
  create: (input: { name: string; donorId?: number | null; managerId?: number | null }) =>
    apiClient.post<{ data: { id: number; programme_reference: string } }>('/api/programmes', input),
  update: (id: number, input: { name: string; donorId?: number | null; managerId?: number | null }) =>
    apiClient.put<{ data: Programme }>(`/api/programmes/${id}`, input),
};
